import React from 'react';
import { Link } from 'react-router-dom';

const AdminPanelSummary = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <Link className="pill-link" to="/admin">
        前往管理后台
      </Link>
    </div>
  );
};

export default AdminPanelSummary;
